import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';
import { useDocumentTitle } from '../utils/useDocumentTitle';

// Lazy load all contest components
const Contest = LazyComponentWithSuspense(() => import('../pages/Contest/ContestHome'));
const ViewAll = LazyComponentWithSuspense(() => import('../components/CodingContests/ContestHome/ViewAll'));
const ContestDetails = LazyComponentWithSuspense(() => import('../pages/Contest/ContestDetails'));
const ContestRanking = LazyComponentWithSuspense(() => import('../pages/Contest/ContestRanking'));
const AllUserCreatedContest = LazyComponentWithSuspense(() => import('../pages/Contest/AllUserCreatedContest'));
const ViewAllContests = LazyComponentWithSuspense(() => import('../pages/Contest/ViewAllContests'));
const ResultUserId = LazyComponentWithSuspense(() => import('../components/Admin/Components/Contest/ResultUserId'));
const PageNotFound = LazyComponentWithSuspense(() => import('../pages/PageNotFound/PageNotFound'));
export const ContestRoutes = () => {
  useDocumentTitle('Contest');
  return (
    <Routes>
      <Route index element={<Contest />} />
      <Route path="/user" element={<AllUserCreatedContest />} />
      <Route path="/rankings" element={<ViewAll />} />
      {/* <Route path="/:contestId" element={<ContestDetails />} /> */}
      <Route path="/:contestId/:time/:contest_code/ranking" element={<ContestRanking />} />
      <Route path="/:contestId/result" element={<ResultUserId />} />
      <Route path="/viewAllContest" element={<ViewAllContests />} />
      <Route path="/:contestId" element={<ContestDetails />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
